<template>
 <div>
  
  <!-- header section -->
  <b-button-group class="mx-2 mt-2">

    <b-dropdown v-if="data" id="dropdown-form" variant="outline-dark" class="mx-1" ref="dropdown" size="sm">
      <template v-slot:button-content>
       <span>&#128467; View</span>
      </template> 

      <b-dropdown-form  style="background-color:whitesmoke;">
            <div class="font-smaller pt-2" style="min-width:250px;">
              <b-form-group  label="Selected view:">
                <b-form-radio v-on:change="viewChange"  v-model="view" name="some-radios" value="current"><b> {{ data.journalDate | moment("dddd, MMMM Do YYYY") }} </b> </b-form-radio>
                <b-form-radio v-model="view" name="some-radios" value="range"><b>Date range...</b></b-form-radio>
              </b-form-group>
            
              <div v-if="view=='range'"> 
              <b-form inline class="py-1">
                  <label style="min-width:60px;">From: </label>
                  <!-- <b-form-datepicker id="datepicker-from" v-model="dteFrom" class="mb-2"></b-form-datepicker> -->
                    <b-form-input type="date" v-model="dteFrom" id="input-to" size="sm" v-on:change="rangeChanged" ></b-form-input>
                </b-form>

              <b-form inline>
                  <label style="min-width:60px;">To: </label>
                  <b-form-input type="date" v-model="dteTo" id="input-from" size="sm" v-on:change="rangeChanged" ></b-form-input>
              </b-form>

              <div class="mt-2" >
                <b-button variant="outline-dark" size="sm" @click="fetchData" class="m-2 float-right" :disabled="dteFrom==''||dteTo==''">
                    <img alt="calendar" src="@/assets/images/download-icon.svg"  height="18x"> Load 
                  <b-spinner small v-if="isBusy"></b-spinner>
                </b-button>
              </div>
        
              </div>
            
            </div>

          </b-dropdown-form>

    </b-dropdown>

    <b-button variant="outline-dark" size="sm" class="mx-1" @click="print"> &#x1F5A8; Print...</b-button>

    <div v-if="data&&view=='current'" class="mt-1 pl-2 pt-1 d-flex ">
      <div>
        <b>({{data.journalDate | moment("YYYY-MM-DD") }})</b>
      </div>
      <div v-if="data.photoCount>0" class="ml-4 pr-3">
        <b-form-checkbox v-model="includePhotos" v-on:change="togglePhotos()">
          <small>Include Photos</small>  
          <span v-if="isBusy" class="text-center p-2"><b-spinner variant="primary" small> </b-spinner></span>
        </b-form-checkbox>
      </div>
    </div>

    <div v-if="journalData&&loaded" class="pl-2 pt-1"> <b>({{dteFrom}} to {{dteTo}})</b>
      {{journalData.length}} Journal Pages
    </div>
    

  </b-button-group>

  <hr class="m-2">
  <!-- end header-->

<!--current journal view -->
<div v-if="view=='current'">
 <div id="printable" v-if="data" class="pt-3" style="max-width: 760px;" >

   <PrintableJournal :data="data" :project="project" :includePhotos="includePhotos" :journalPhotos="journalPhotos"> </PrintableJournal> 

 </div>

</div>


<!-- date range journal data view  -->
<div v-if="view=='range'">
 <div id="printable" v-if="journalData" class="pt-3" style="max-width: 760px;">

  <div v-for="(data, index) in journalData" :key="index">

    <PrintableJournal :data="data" :project="project"> </PrintableJournal>

  </div>

 </div>

</div>
<!-- end -->
 
</div>
</template>

<script>
import PrintableJournal from "@/components/journal/PrintableJournal.vue";
export default {
  name: "JournalView",
  props: {
      data: Object,
      project: Object
  },
  components: { PrintableJournal },
  
  data: function() {
    return {
      journalData: null,
      view: "current",
      dteFrom: "",
      dteTo: "",
      loaded: false,
      dataerror: "",
      isBusy: false,
      includePhotos: false, 
      journalPhotos: null
    }
  },
  
  methods: {

    togglePhotos() {
      if (!this.journalPhotos) {
        this.fetchPhotos();
      }
      
    },

     print () {
      // Pass the element id here
      this.$htmlToPaper('printable');
    },
 

    viewChange() {
     //in radio option, view changed back to current
     this.journalData = null;
     this.loaded = false;
     this.$refs.dropdown.hide(true);

    },

    rangeChanged() {
      this.journalData = null;
      this.loaded = false;
    },

    fetchData() {
      this.isBusy = true;
      this.$auth.acquireToken().then(token => {
        this.$http
          .get("api/JournalData/"+ this.project.projectId +"/"+ this.dteFrom +"/"+ this.dteTo, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.journalData = response.data;
            this.loaded = true;
            this.$refs.dropdown.hide(true);
          })
          .catch(error => {
            this.dataError = true;
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => (this.isBusy = false));
      });
    },

    fetchPhotos() {
      this.isBusy = true;
      var strDate = this.$moment(this.data.journalDate).format('YYYYMMDD');
      this.$auth.acquireToken().then(token => {
        this.$http
          .get("api/JournalPhotos/"+ this.project.projectId +"/"+ strDate, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.journalPhotos = response.data;
           
          })
          .catch(error => {
            this.dataError = true;
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => (this.isBusy = false));
      });
    }    

  },

 updated: function() {
   
}

}
</script>

<style scoped>

#printable{
  color: black;
}

.font-smaller{
  font-size: .875rem;
}


</style>